import { useEffect, Component, useState, useCallback } from "react";
import Lenis from "lenis";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IntroSplit from "./components/IntroSplit";
import TravelTech from "./components/TravelTech";
import EveryBusiness from "./components/EveryBusiness";
import AIProducts from "./components/AIProducts";
import ImplementationPartner from "./components/ImplementationPartner";
import HowWeWork from "./components/HowWeWork";
import Proof from "./components/Proof";
import Industries from "./components/Industries";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ContactModal from "./components/ContactModal";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink text-white">
          Something went wrong. Please refresh.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useCallback(() => setModalOpen(true), []);
  const closeModal = useCallback(() => setModalOpen(false), []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -76 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-ink">
        <Navbar />
        <main>
          <Hero />
          <IntroSplit />
          <TravelTech />
          <EveryBusiness />
          <AIProducts />
          <ImplementationPartner />
          <HowWeWork />
          <Proof />
          <Industries />
          <CtaSection onBookCall={openModal} />
        </main>
        <Footer />
        <ContactModal open={modalOpen} onClose={closeModal} />
        <FloatingWhatsApp />
      </div>
    </ErrorBoundary>
  );
}
